<div class="d-flex flex-column form-group" id="{{id}}-group"  [formGroup]="customFormGroup">
  <div class="flex-grow-1" style="margin-top:1ch;margin-bottom:1ch;">
    <label [class.sr-only]="hideLabel" [for]="'input-'+id"  [id]="'sfklabel-'+id" data-cy="custom-label">
      {{ label }}
    </label>
    @if (!!infoText && infoText.length > 0) {
      <fa-icon class="infoIcon"
               [icon]="faInfo"
               [title]="infoText"
               data-cy="custom-info"
      ></fa-icon>
    }
    @if (environment.displayTextbausteinKeys) {
      <span>{{infoText}}</span>
    }
  </div>
  @if (!!infoTextBelowInput && infoTextBelowInput.length > 0) {
    <p>
      <strong>{{ infoTextBelowInput }}</strong>
    </p>
  }
 	<div>
		@for (option of options; track option.value) {
      <div class="form-check " [ngClass]="{'form-check-disabled' : readonly, 'form-check-active' : !readonly}"><!--uncomment class for nebeneinander und nicht untereinander form-check-inline -->
        <label class="form-check-label custom-radio-container"
          >{{option.name | translate}}
          @if (!readonly) {
            <input
              class="form-check-input mx-2"
              type="radio"
              [id]="'input-' + id"
              [value]="option.value"
              [formControlName]="id"
              (change)="triggerOnChange($event)"
              data-cy="custom-input"
            />
          }
          @if (readonly) {
            <input
              class="form-check-input mx-2"
              type="radio"
              [id]="'input-' + id"
              [value]="option.value"
              [formControlName]="id"
              [attr.disabled]="readonly"
            />
          }
          <span class="checkmark"
                [attr.disabled]="readonly"
                [attr.data-cy]="'radio-option-'+option.value"
          ></span>
        </label>
        @if (option.info && option.info.length > 0) {
          <p class="ms-4 mt-1 text-muted sonderfall-info">
            <small [innerHTML]="option.info | safeHtml"></small>
          </p>
        }
      </div>
    }
	</div>
</div>

